export default {
    namespaced: true,
    state: {
        list: window.regionTorg?.preload?.regions ?? [],
        listNoCache: [],
    },
    mutations: {
        setRegions: (state, regions) => state.list = [...regions],
        setRegionsNoCache: (state, regions) => state.listNoCache = [...regions]
    },
    actions: {
        fetchList: ({state, commit}) => {
            if(state.list.length > 0) {
                return;
            }
            return axios.get('/regions')
                .then( res => commit('setRegions', res.data))
                .catch( err => console.error(err))
        },
        fetchListNoCache: ({state, commit}) => {
            return axios.get('/regionsNoCache')
                .then( res => commit('setRegionsNoCache', res.data))
                .catch( err => console.error(err))
        }
    }
}
